package ru.it_mozaika.sender.js.application.components

import js.core.jso
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.aria.AriaRole
import react.dom.aria.ariaLabel
import react.dom.aria.ariaLabelledBy
import react.dom.events.ChangeEvent
import react.dom.html.ReactHTML.div
import ru.it_mozaika.components.tableHead
import ru.it_mozaika.sender.common.models.ColumnsFilter
import ru.it_mozaika.sender.js.application.context.useTable

import tanstack.react.table.renderCell
import tanstack.react.virtual.UseVirtualizerOptions
import tanstack.react.virtual.useVirtualizer
import tanstack.table.core.Table
import web.cssom.*
import web.html.HTMLDivElement
import web.html.HTMLInputElement

external interface TableSkeletonProps: TableContainerProps {
    var onPropertySelect: (String) -> Unit
    var columnsWithFilter: List<String>
    var table: Table<*>
    var columnId: String
    var label: String
    var onDoubleClickHandler: (String) -> Unit
    var toolbarActions: ReactNode?
    var showCheckBox: Boolean?
    var showFilter: Boolean?
}

val TableSkeletonFrame = FC<TableSkeletonProps> { props ->
    val tableContext = useTable()
    val selected = tableContext.selected
    val isSelected: (String) -> Boolean = { name ->
        selected.indexOf(name) != -1
    }

    val parentRef = useRef<HTMLDivElement>()
    val virtualList = useVirtualizer(
        jso<UseVirtualizerOptions<HTMLDivElement, HTMLDivElement>> {
            this.getScrollElement = useCallback(parentRef.current) { parentRef.current }
            this.estimateSize = { 5 }
            overscan = 30
            this.count = props.table.getRowModel().rows.size
        }
    )
    val handleSelectAllClick: (ChangeEvent<HTMLInputElement>) -> Unit = { event ->
        if (event.target.checked) {
            val newSelected = props.table.getRowModel().rows.map { row ->
                row.getValue(props.columnId).toString()
            }
            tableContext.setSelected(newSelected)
        } else {
            tableContext.setSelected(emptyList())
        }
    }

    val handleClick: (String) -> Unit = { name: String ->
        tableContext.toggleSelect(name)
    }

    if (selected.isNotEmpty()) {
//        Divider {
//            this.orientation = Orientation.horizontal
//        }
        Grid {
            direction = responsive(GridDirection.row)
//                    asDynamic().justifyContent = "space-between"
            container = true
            sx {
                padding = 5.px
                this.alignItems = AlignItems.center
                justifyContent = JustifyContent.spaceBetween
            }
            Grid {
                item = true
                Stack {
                    direction = responsive(StackDirection.row)
                    spacing = responsive(5.px)
                    sx {
                        padding = 5.px
                        this.alignItems = AlignItems.center
                    }
                    if (props.showCheckBox == true || props.showCheckBox == null || props.showCheckBox == undefined) {
                        Checkbox {
                            val rowCount = props.table.getRowModel().rows.size
                            color = CheckboxColor.secondary
                            indeterminate = selected.size > 0 && selected.size < rowCount
                            checked = rowCount > 0 && selected.size == rowCount
                            onChange = { event, _ ->
                                handleSelectAllClick(event)
                            }
                            ariaLabel = "Выбрать все"
                        }
                    }
                    Typography {
                        sx {
                            flexGrow = number(1.0)
                        }
                        +" Выбрано: ${selected.size}"
                        variant = TypographyVariant.h4
                        id = "table-title"
                        component = div
                    }
                }
            }
            Grid {
                item = true
                +props.toolbarActions
            }
        }
        Divider {
            this.orientation = Orientation.horizontal
        }
    }
    TableContainer {
        ref = parentRef
        sx {
            maxHeight = 100.vh - 300.px
        }
        Table {
            ariaLabel = "${props.label}-table"
            ariaLabelledBy = "${props.label}-table-title"
            stickyHeader = true
            tableHead {
                this.showCheckBox = props.showCheckBox
                this.table = props.table
                if (undefined != props.columnsWithFilter) {
                    this.propertiesWithFilters = props.columnsWithFilter
                }
                this.onFilterClick = { propertyId ->
                    props.onPropertySelect(propertyId)
                }
                this.numSelected = selected.size
                this.onSelectAllClick = handleSelectAllClick
                this.rowCount = table.getRowModel().rows.size
                this.showFilter = props.showFilter

            }

            TableBody {
                virtualList.getVirtualItems().forEach { item ->
                    val row = props.table.getRowModel().rows[item.index]
                    val cellValue = row.getValue(props.columnId).toString()
                    val isItemSelected = isSelected(cellValue)
                    val labelId = "${props.label}-table-row-${item.index}"
                    TableRow {
                        role = AriaRole.checkbox
                        tabIndex = -1
                        key = cellValue
//                        this.selected = isItemSelected
                        sx {
                            cursor = Cursor.pointer
                        }
                        hover = true
                        if (props.showCheckBox == true || props.showCheckBox == null || props.showCheckBox == undefined) {
                            TableCell {
                                padding = TableCellPadding.checkbox

                                Checkbox {
                                    onClick = {
                                        handleClick(cellValue)

                                    }
                                    color = CheckboxColor.secondary
                                    checked =
                                        isItemSelected
                                    inputProps = jso {
                                        ariaLabelledBy = labelId
                                    }
                                }

                            }
                        }
                        row.getVisibleCells().forEachIndexed { index, cell ->
                            TableCell {
//                                component = ReactHTML.td
                                onDoubleClick = {
                                    props.onDoubleClickHandler(cellValue)
                                }
//                                if (index == 0) {
//                                    component = ReactHTML.th
                                id = labelId
                                scope = "row"
//                                    padding = TableCellPadding.none
//                                    align = TableCellAlign.center

//                                }
                                +renderCell(cell)
                            }
                        }
                    }
                }
            }
        }
    }
}